import { render, staticRenderFns } from "./ProjectCostTab.vue?vue&type=template&id=196a6fc2&scoped=true"
import script from "./ProjectCostTab.vue?vue&type=script&lang=js"
export * from "./ProjectCostTab.vue?vue&type=script&lang=js"
import style0 from "./ProjectCostTab.vue?vue&type=style&index=0&id=196a6fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196a6fc2",
  null
  
)

export default component.exports